// App entry: the authenticated user app on app.outclose.com. The whole
// deployable is MainApp at the domain root; /admin is redirected at the edge
// by this target's _redirects.
import MainApp from "../apps/main/MainApp";
import { useReferralCapture } from "../lib/referral";
import { renderRoot } from "../bootstrap";

function AppRoot() {
  // Referral links can land anywhere, including the app subdomain.
  useReferralCapture();
  return <MainApp basePath="/" />;
}

renderRoot(<AppRoot />);
